'use client';
import { ArrowChevronOpenIcon } from '@avtopro/icons';
import { useTranslations } from 'next-intl';

interface ScrollUpProps {
	className?: string;
}

const ScrollUp = ({ className = '' }: ScrollUpProps) => {
	const handleClick = () => {
		window.scroll({ top: 0, behavior: 'smooth' });
	};
	const t = useTranslations('Common');
	return (
		<button
			type="button"
			onClick={handleClick}
			value={t('scrollUp')}
			aria-label={t('scrollUp')}
			className={`flex h-8 w-8 rotate-180 cursor-pointer items-center justify-center md:hidden ${className}`}>
			<ArrowChevronOpenIcon className="text-blue-deep" />
		</button>
	);
};
export default ScrollUp;
